import { EuiGlobalToastList } from '@kergoquod/eui'
import { useToasts } from './toast-store'

const Toasts = () => {
  const { toasts, removeToast } = useToasts()

  return (
    <EuiGlobalToastList
      toasts={toasts}
      dismissToast={removeToast}
      toastLifeTimeMs={10000}
    />
  )
}

export default Toasts
